const CloseIcon = () => `<svg width="100%" height="100%" viewBox="0 0 24 25" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.5321 4.6837L11.9989 11.1851L5.46671 4.6837L4 6.14452L10.5312 12.6469L4 19.1473L5.46671 20.6081L11.9989 14.1078L18.5321 20.6081L19.9999 19.1473L13.4677 12.6469L19.9999 6.14452L18.5321 4.6837Z" fill="currentColor"/>
  </svg>
  `;
export default CloseIcon;
